enum EParticipantsPromotion {
  ONLY_CUSTOMERS = 'only_customers',
  ALL_CUSTOMERS = 'all_customers',
}

export default EParticipantsPromotion;
